document.querySelectorAll('.pg-slider-section').forEach(function (section) {
  var tabs = section.querySelectorAll('.pg-slider__tab');
  var panels = section.querySelectorAll('.pg-slider__panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab-target');

      tabs.forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-panel') === target;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });
  });

  section.querySelectorAll('.pg-slider__wrapper').forEach(function (wrapper) {
    var track = wrapper.querySelector('.pg-slider__track');
    var prevBtn = wrapper.querySelector('.pg-slider__arrow--prev');
    var nextBtn = wrapper.querySelector('.pg-slider__arrow--next');
    if (!track || !prevBtn || !nextBtn) return;

    function scrollAmount() {
      var slide = track.querySelector('.pg-slide');
      if (!slide) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 16);
      return slide.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  });
});
